import styled from "styled-components";
import { ButtonHoC } from "../button.js";
export const ButtonPrimaryInternal = styled.button`
  align-items: center;
  background-color: ${props => props.theme.colors.action};
  border: 0;
  border-radius: 4px;
  box-sizing: border-box;
  color: ${props => props.theme.colors.buttonPrimaryText};
  cursor: pointer;
  display: flex;
  ${props => props.theme.fonts.default}
  font-size: 17px;
  font-weight: 600;
  justify-content: center;
  line-height: 22px;
  outline: 0;
  padding: 9px 12px;
  text-align: center;
  min-width: 184px;
  width: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &:hover,
  &:focus {
    background-color: ${props => props.theme.colors.buttonPrimaryBgHover};
    box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.32);
  }
  &:disabled {
    background-color: ${props => props.theme.colors.buttonPrimaryBgDisabled};
    color: ${props => props.theme.colors.buttonPrimaryTextDisabled};
    cursor: default;
    box-shadow: none;
  }
`;
export const ButtonPrimary = ButtonHoC(ButtonPrimaryInternal);
export const ButtonPrimarySmallInternal = styled(ButtonPrimaryInternal)`min-width: 84px;`;
export const ButtonPrimarySmall = ButtonHoC(ButtonPrimarySmallInternal);